import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-parere-view',
  templateUrl: './form-parere-view.component.html',
  styleUrls: ['./form-parere-view.component.css']
})
export class FormParereViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
